module.exports = __webpack_public_path__ + "static/media/proemailPremiumInverted.5845be5d.svg";